export default __webpack_public_path__ + "static/media/especializadas-farm.9d4bf027.png";